import React from "react";

import { SecondaryButton } from "~/components/common/buttons";

interface Error {
  sheet: string;
  row?: number | null;
  column?: string | null;
  message: string;
}

interface Props {
  errors: Error[];
  onBack: () => void;
}

export const ValidateErrorsStep = ({ errors, onBack }: Props) => (
  <div>
    <h5 className="text-danger mb-3">Validation Errors</h5>
    <p>Please fix the following errors in your spreadsheet and re-upload.</p>
    <ul className="list-unstyled">
      {errors.map((e, i) => (
        <li key={i} className="mb-1">
          <span className="text-danger">
            {e.sheet && <strong>{e.sheet}: </strong>}
            {e.row != null && `Row ${e.row} `}
            {e.column && `(${e.column}) `}
            {e.message}
          </span>
        </li>
      ))}
    </ul>
    <div className="d-flex justify-content-start mt-3">
      <SecondaryButton onClick={onBack}>Back — re-upload</SecondaryButton>
    </div>
  </div>
);
